

import SlimSelect from "slim-select";

/**
 * My preferences for defaults and settings
 * @see https://github.com/brianvoe/slim-select
 * @see https://www.npmjs.com/package/slim-select
 * @type {Object}
 */
const generalSettings = {
    showSearch: false,
    closeOnSelect: true,
    allowDeselect: true,
    placeholderText: '--Please select--',
};

function init() {
    const selects = document.querySelectorAll( '.wpcf7-select' );

    selects.forEach( select => {
        const settings = { ...generalSettings };
        const placeholder = select.firstElementChild;

        if ( placeholder?.hasAttribute( 'disabled' ) ) {
            const placeholderText = select.firstElementChild?.textContent;
            settings.placeholderText = placeholderText;
            placeholder.remove();
        }

        if ( select.hasAttribute( 'multiple' ) ) {
            settings.closeOnSelect = false;
        }

        new SlimSelect( {
            select,
            settings,
        } );
    } );
}

document.addEventListener( 'DOMContentLoaded', init );